import { render, staticRenderFns } from "./NoVerifyPage.vue?vue&type=template&id=14901654&scoped=true&"
import script from "./NoVerifyPage.vue?vue&type=script&lang=js&"
export * from "./NoVerifyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14901654",
  null
  
)

export default component.exports